var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reply"},[_c('div',{staticClass:"close-reply",on:{"click":_vm.close}},[_c('i',{staticClass:"el-icon-close"})]),_c('div',{staticClass:"reply-message"},[_c('p',[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }